<template>
  <div class="personal_commen">
    <!-- 公用头部 -->
     <header>
      <div class="w_d">
        <PersonalHeader :webUserInfo="webUserInfo"></PersonalHeader>
      </div>
    </header>
    <MyBreadCrumb
      v-if="$route.path !== '/personalheader'"
      :is_index="false"
    ></MyBreadCrumb>
     <div class="content">
         <router-view></router-view>
     </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webUserInfo: {},
      is_pay:false,
    };
  },
  methods:{
      getWay(val){
        console.log(val,"1545455");
        this.is_pay = val;
      }
  },
  created() {

    // 获取用户信息
    let webUserInfo = JSON.parse(localStorage.getItem("webUserInfo"));
    if (webUserInfo) {
      this.webUserInfo = webUserInfo;
    }
    console.log(this.$route);
  },
};
</script>
 
<style lang = "less" scoped>
.personal_commen {
  header {
    height: 250px;
    background: url("../../assets/images/成果认定/banner.png") no-repeat center
      center;
    position: relative;
  }
}
</style>